import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';
// icons
import ICONS from '../../constants/icons';

// hooks
import useGoBack from '../../hooks/useGoBack';

// components
import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';

interface BackButtonProps {
    destination?: string;
    tooltip: string;
    backHandler?: () => void;
}

const BackButton: React.FC<React.PropsWithChildren<BackButtonProps>> = ({
    destination,
    tooltip,
    backHandler,
}) => {
    const { back, text } = useGoBack(destination ?? '', tooltip);

    return (
        <AampeTooltip title={text}>
            <Container onClick={backHandler ?? back}>
                <StyledArrow />
            </Container>
        </AampeTooltip>
    );
};

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'inherit',
    color: aampeTheme.colors.textAccessibleWG01,
    width: '24px',
    height: '24px',
    cursor: 'pointer',
});

const StyledArrow = styled(ICONS.leftChevron)`
    font-size: ${aampeTheme.size.font.default};
`;

export default BackButton;
